import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";
import Draggable from "react-draggable";
import Icon from "../Icon";
import Item from "./Item";

const MAX_REMIX = {
  head: 9,
  top: 8,
  bottom: 8,
};

const POPUP_WIDTH = 152;
const POPUP_HEIGHT = 328;

const Remix = React.memo(({
  mouse,
  visible,
  remix,
  head,
  top,
  bottom,
  onClick,
  onChange = () => { },
  onHide,
  onMouseEnter,
  onMouseLeave
}) => {

  const [x, setX] = useState();
  const [y, setY] = useState();

  const [active, setActive] = useState(0);

  const nodeRef = React.useRef(null);

  useEffect(() => {
    if ((mouse.x + POPUP_WIDTH) > window.innerWidth) {
      setX(window.innerWidth - POPUP_WIDTH);
    } else {
      setX(mouse.x);
    }
    if ((mouse.y + POPUP_HEIGHT) > window.innerHeight) {
      setY(window.innerHeight - POPUP_HEIGHT);
    } else {
      setY(mouse.y);
    }

  }, [mouse]);

  const handleStop = (e, data) => {
    setX(data.lastX);
    setY(data.lastY);
  }

  const handleRemix = useCallback(
    (type, direction) => {
      const maxId = MAX_REMIX?.[type];
      const currentId = +remix?.[type];
      const prevId = currentId - 1 < 1 ? maxId : currentId - 1;
      const nextId = currentId + 1 > maxId ? 1 : currentId + 1;

      if (direction === "prev") {
        onChange({ ...remix, [type]: prevId });
      }
      if (direction === "next") {
        onChange({ ...remix, [type]: nextId });
      }
    },
    [remix, onChange]
  );

  const sections = [
    {
      type: "head",
      background: head
    },
    {
      type: "top",
      background: top
    },
    {
      type: "bottom",
      background: bottom
    }
  ];

  return (
    <Draggable
      position={{ x: x, y: y }}
      onStop={handleStop}
      handle=".popup__head"
      bounds={{
        top: 0,
        left: 0,
        right: window.innerWidth - 152,
        bottom: window.innerHeight - 328
      }}
      nodeRef={nodeRef}>
      <div className="popup popup--remix"
        onClick={onClick}
        ref={nodeRef}>
        <div className={cn("popup__container", { visible: visible })}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <button className="popup__close" onClick={onHide}>
            <Icon.Close />
          </button>
          <div className="popup__head">Remix</div>
          <div className="popup__body">
            <div className="remix">
              {sections.map((section, index) =>
                <Item
                  section={section}
                  index={index}
                  active={active}
                  setActive={() => setActive(index)}
                  handleRemix={handleRemix}
                  key={index}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Draggable >
  );
});

Remix.displayName = 'Remix';

export default Remix;